var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-download-nfplus-wrapper",on:{"click":_vm.handleClickDownload}},[(_vm.downloadBg)?_c('img',{staticClass:"img-download",attrs:{"src":_vm.downloadBg}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }